<template>
  <div class="edit">
    <el-form
      :model="editForm"
      ref="editForm"
      :rules="editRules"
      label-width="160px"
      size="small"
      style="width: 600px"
    >
      <el-form-item label="用线长度:" prop="lineLength">
        <el-input
          v-model="editForm.lineLength"
          placeholder="请输入用线长度"
          type="number"
          step="0.1"
        ></el-input>
      </el-form-item>
      <el-form-item label="增项费用:" prop="addOutlay">
        <el-input
          v-model="editForm.addOutlay"
          placeholder="请输入增项费用"
          type="number"
          step="0.01"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { validateNumber } from "@/utils/index";
export default {
  props: {
    currentData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    currentData: {
      handler(newVal) {
        this.editForm.lineLength = newVal.lineLength || "";
        this.editForm.addOutlay = newVal.addOutlay || "";
      },
      immediate: true,
    },
  },
  data() {
    return {
      editForm: {
        lineLength: "",
        addOutlay: "",
      },
      editRules: {
        lineLength: [
          { validator: this.validateLineLength, trigger: "blur" },
        ],
        addOutlay: [
          { validator: validateNumber, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    validateLineLength(rule, value, callback) {
      if (value === "" || value === null || value === undefined) {
        callback();
        return;
      }
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        callback(new Error("请输入有效的数字"));
      } else if (numValue < 0) {
        callback(new Error("用线长度不能为负数"));
      } else {
        callback();
      }
    },
    // 提交表单
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.axios({
            method: "post",
            url: `/pending-settlement-order/edit/line-addoutlay/${this.currentData.id}`,
            data: {
              id: this.currentData.id,
              lineLength: this.editForm.lineLength === "" ? null : parseFloat(this.editForm.lineLength),
              addOutlay: this.editForm.addOutlay === "" ? null : parseFloat(this.editForm.addOutlay),
            },
          }).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message || "编辑成功",
                type: "success",
              });
              this.$emit("editSuccess");
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.edit {
  margin-top: 20px;
}
</style>


